module.exports = __webpack_public_path__ + "img/outro-banco.d01fc8ac.svg";